export interface DocumentUrlNameDto {
  url: string | null
  filename: string | null
}

interface DocumentUrlName {
  url: string
  filename: string
}

export const isDocumentUrlExists = (
  documentUrl: DocumentUrlNameDto
): documentUrl is DocumentUrlName => {
  return !!(documentUrl?.url && documentUrl?.filename)
}
